// import RecipeLayout from "../components/Recipes/RecipeLayout";
import SearchedRecipe from "../components/Recipes/SearchedRecipe";

const RecipePage = (): JSX.Element => {
  return <SearchedRecipe />;
};

export default RecipePage;
